import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import BreadcrumbHomeItem from './BreadcrumbHomeItem';
import BreadcrumbItem from './BreadcrumbItem';
import BreadcrumbLink from './BreadcrumbLink';
import styles from './breadcrumbs.module.scss';

interface Props {
  contentType: "children" | "links";
  children?: ReactNode;
  links?: BreadcrumbLink[];
  includeHomeLink?: boolean;
  onMobileOnlyBackLink?: boolean;
  className?: string;
}

const Breadcrumbs = ({ contentType, children, links, includeHomeLink, onMobileOnlyBackLink, className }: Props) => {
  // translations
  const tLabels = useTranslation("shared\\components").t;

  // sub-renders
  const rednerHomeLink = () => {
    if (includeHomeLink) {
      if (onMobileOnlyBackLink) {
        return (
          <BreadcrumbHomeItem />
        );
      } else {
        return <BreadcrumbItem icon="home" to="/" />
      }
    }    
  }

  const renderChildren = () => {
    if (children) {
      return <>{children}</>;
    }
    return null;
  }

  const renderLinks = () => {
    if (links) {
      let result: JSX.Element[] = [];
      let lenght = links.length;
      for (let i = 0; i < lenght; i++) {
        const link = links[i];
        const elem = <BreadcrumbItem {...link} key={i} active={i == lenght - 1} />;
        result.push(elem);
      }

      return result;
    } 
    return null;   
  }

  const renderContent = () => {
    switch (contentType) {
      case "children":
        return renderChildren();
      case "links":
        return renderLinks();
      default:
        return null;
    }  
  }
  
  // render
  return (
    <nav aria-label="breadcrumb" className={className ?? undefined}>
      <ol className={`breadcrumb${onMobileOnlyBackLink ? ` ${styles.mobileBreadcrumbs}` : ""}`}>
        {rednerHomeLink()}
        {renderContent()}
      </ol>
    </nav>
  )
}

export default Breadcrumbs;
